<template>
  <div ref="el">
    <slot v-bind="{ voucherVariantTrigger }" />
  </div>
</template>
<script>
import { ref } from 'vue'

const basketRect = ref(null)

export { basketRect }

export default {
  props: {
    separator: {
      type: Boolean,
      default: true
    }
  },
  inject: {
    animate: {
      default: false
    },
    bounding: {}
  },
  data() {
    return {
      fixed: false,
      boundingRect: null,
      lastScrollY: 0,
      ticking: false,
      detailSectionBoundingRect: null,
      scrollDir: 0,
      prevScrollY: 0,
      lastHeight: 0
    }
  },
  methods: {
    voucherVariantTrigger(id) {
      if (
        this.$formValues['frm-bf-form-dk_voucher_variant_id'] !== null &&
        Number.parseInt(this.$formValues['frm-bf-form-dk_voucher_variant_id']) ===
          Number.parseInt(id)
      ) {
        this.$formValues['frm-bf-form-dk_voucher_variant_id'] = null
      }
    },

    checkHeightChange() {
      if (!this.$refs.el) return

      const currentHeight = this.$refs.el.offsetHeight
      if (currentHeight !== this.lastHeight) {
        this.lastHeight = currentHeight
        // Trigger resize event after a short delay
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'))
        }, 50)
      }
    },
    scroll(lastScrollY) {
      this.detailSectionBoundingRect = this.bounding()
      const sectionBottom =
        this.detailSectionBoundingRect.height + this.detailSectionBoundingRect.top + lastScrollY

      if (lastScrollY < this.prevScrollY) {
        this.scrollDir = -1
      } else {
        this.scrollDir = 1
      }

      this.prevScrollY = lastScrollY

      if (this.scrollDir === 1 && this.$refs.el.style.position === 'fixed') {
        if (
          lastScrollY +
            basketRect.value.height +
            (window.innerHeight - 24 - basketRect.value.height) >=
          sectionBottom
        ) {
          this.$refs.el.style.position = 'absolute'
          this.$refs.el.style.bottom = 0
        }
      } else if (this.scrollDir === -1 && this.$refs.el.style.position === 'absolute') {
        if (
          lastScrollY +
            basketRect.value.height +
            (window.innerHeight - 24 - basketRect.value.height) <=
          sectionBottom
        ) {
          this.$refs.el.style.position = 'fixed'
          this.$refs.el.style.bottom = '24px'
        }
      }
    },
    onScrollWatcher() {
      this.lastScrollY = window.scrollY
      this.scroll(this.lastScrollY)
      /*
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.ticking = false
        })

        this.ticking = true
      }
      */
    },
    onResize() {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout)
      }

      this.resizeTimeout = setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.el.style = null

          this.$nextTick(() => {
            basketRect.value = this.$refs.el.getBoundingClientRect()
            this.detailSectionBoundingRect = this.bounding()
            const sectionBottom =
              this.detailSectionBoundingRect.height +
              this.detailSectionBoundingRect.top +
              window.scrollY

            if (sectionBottom <= window.innerHeight - 24 - basketRect.value.height) {
              this.$refs.el.style.position = 'absolute'
              this.$refs.el.style.bottom = 0
            } else {
              this.$refs.el.style.position = 'fixed'
              this.$refs.el.style.bottom = '24px'
            }

            this.$refs.el.style.left = basketRect.value.left + 'px'
            this.$refs.el.style.width = basketRect.value.width + 'px'
            this.$refs.el.style.height = basketRect.value.height + 'px'
            this.$refs.el.style.zIndex = 50

            this.onScrollWatcher()
          })
        })
      }, 100)
    }
  },
  mounted() {
    if (!this.animate) {
      return
    }

    // Initial height check
    this.lastHeight = this.$refs.el?.offsetHeight || 0

    // Set up interval to check height changes
    this.heightCheckInterval = setInterval(() => {
      this.checkHeightChange()
    }, 100)

    setTimeout(() => {
      basketRect.value = this.$refs.el.getBoundingClientRect()
      this.detailSectionBoundingRect = this.bounding()
      const sectionBottom =
        this.detailSectionBoundingRect.height + this.detailSectionBoundingRect.top + window.scrollY

      if (sectionBottom <= window.innerHeight - 24 - basketRect.value.height) {
        this.$refs.el.style.position = 'absolute'
        this.$refs.el.style.bottom = 0
      } else {
        this.$refs.el.style.position = 'fixed'
        this.$refs.el.style.bottom = '24px'
      }

      this.$refs.el.style.left = basketRect.value.left + 'px'
      this.$refs.el.style.width = basketRect.value.width + 'px'
      this.$refs.el.style.height = basketRect.value.height + 'px'
      this.$refs.el.style.zIndex = 50
    }, 100)

    //this.$refs.el.style.backgroundColor = 'white'
    window.addEventListener('scroll', this.onScrollWatcher)
    window.addEventListener('resize', this.onResize)
  },
  unmounted() {
    if (!this.animate) {
      return
    }

    if (this.heightCheckInterval) {
      clearInterval(this.heightCheckInterval)
    }

    window.removeEventListener('scroll', this.onScrollWatcher)
    window.removeEventListener('resize', this.onResize)
  }
}
</script>
